<div class="providers-container flex flex-col min-h-screen w-full h-full">
    @if (isLoading() === false) {
    <app-title-section [title]="'Liste des prestataires'"></app-title-section>

    <div class="providers-content w-full h-full flex flex-col items-center mt-12">
            @if (providers().length > 0) {
            <p-dataview class="w-full" #dv [value]="providers()" [rows]="10" [paginator]="true">
                <ng-template #list let-providers>
                <div class="flex flex-col gap-y-4">
                    @for (provider of providers; track provider.id) {
                        <div class="card w-full cursor-pointer" (click)="selectProvider(provider)">
                            <div class="flex items-center gap-3 p-1 w-full">
                                <!-- Infos principales -->
                                <div class="flex flex-col flex-1 gap-y-2">
                                    <div class="flex items-center justify-between gap-2">
                                        @if (provider.firstName && provider.lastName) {
                                            <span class="font-semibold">{{ provider.firstName }} {{ provider.lastName }}</span>
                                        } @else {
                                            <span class="font-semibold text-red-400">Profil incomplet</span>
                                        }
                                        <!-- Badge vérifié conditionnel -->
                                        @if (provider.verified) {
                                            <p-chip class="verified-chip">
                                                <app-icon-svg 
                                                    class="search-icon"
                                                    width="16" 
                                                    height="16" 
                                                    iconName="success-chip" 
                                                    color="#347A79"
                                                ></app-icon-svg>
                                                <span class="text-sm">Vérifié</span>
                                            </p-chip>
                                        } @else {
                                            <p-chip class="not-verified-chip">
                                                <app-icon-svg 
                                                    class="search-icon"
                                                    width="16" 
                                                    height="16" 
                                                    iconName="error-chip" 
                                                    color="#de8700"
                                                ></app-icon-svg>
                                                <span class="text-sm">Non Vérifié</span>
                                            </p-chip>
                                        }
                                    </div>
                                    <div class="flex flex-col gap-y-4">
                                        <div class="flex items-center gap-x-1">
                                            <app-icon-svg 
                                                class="search-icon"
                                                width="12" 
                                                height="12" 
                                                iconName="user" 
                                                color="#57636c"
                                            ></app-icon-svg>
                                            <span class="text-sm">{{ provider.email }}</span>
                                        </div>
                                        @if (provider.companyName) {
                                        <div class="flex items-center gap-x-1">
                                            <app-icon-svg 
                                                class="search-icon"
                                                width="12" 
                                                height="12" 
                                                iconName="cgu-cgv"
                                                color="#57636c"
                                            ></app-icon-svg>
                                            <span class="text-sm">{{ provider.companyName }}</span>
                                        </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>    
                    }
                </div>
                </ng-template>
            </p-dataview>
        } @else {
            <div class="flex-1 flex flex-col items-center justify-center gap-y-8">
                <div class="rounded relative">
                    <app-icon-svg 
                        class="search-icon"
                        width="64" 
                        height="64" 
                        iconName="search" 
                        color="#57636c"
                    ></app-icon-svg>
                </div>
                <p class="description">Recherchez un prestataire par email ou nom d'entreprise</p>
            </div>
        }
    </div>
    } @else {
    <!-- Loading -->
    <div class="loading-spinner flex justify-center">
        <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s" class="progress-spinner" />
    </div>
    }
</div>